import { supabaseClient } from '../../services/supabase';

export default async function PercentageNoHealthInsuranceRowSupabase(location_name) {
  try {
    // Query Supabase for health insurance data
    const { data, error } = await supabaseClient
      .from('percent_no_health_insure')
      .select('*')
      .or(`location_name.ilike.%${location_name}%,location_name.ilike.%California%`)
      .order('year', { ascending: true });

    if (error) throw error;

    // Get available years for the location
    const locationData = data.filter(row => row.location_name === location_name);
    const californiaData = data.filter(row => row.location_name === 'California');
    
    if (locationData.length === 0 || californiaData.length === 0) {
      return {
        indicator1: 'N/A',
        indicator2: 'N/A',
        smartNarrative: 'Smart narrative unavailable.'
      };
    }
    
    // Get first and last available years
    const years = locationData.map(row => row.year).sort((a, b) => a - b);
    const firstYear = years[0];
    const lastYear = years[years.length - 1];
    
    const first = locationData.find(row => row.year === firstYear);
    const last = locationData.find(row => row.year === lastYear);

    // Check if the data has the required properties
    if (!last.percent_no_insurance || !first.percent_no_insurance) {
      return {
        indicator1: 'N/A',
        indicator2: 'N/A',
        smartNarrative: 'Smart narrative unavailable - missing data.'
      };
    }

    const diff = (last.percent_no_insurance - first.percent_no_insurance).toFixed(1);
    const trend = diff > 0 ? 'increased' : 'decreased';
    const absChange = Math.abs(diff);

    const indicator1 = `${last.percent_no_insurance.toFixed(1)}%`;
    const indicator2 = `${diff}%`;

    const smartNarrative = `Across many counties and places, the percentage of people with health insurance began significantly increasing between the years 2013 and 2018. For ${location_name}, the percentage of people without health insurance ${trend} by ${absChange}% from ${firstYear} to ${lastYear}. For California, health insurance coverage decreased by ${(17.8 - 7.2).toFixed(1)}%.`;

    return { indicator1, indicator2, smartNarrative };

  } catch (err) {
    console.error('Failed to generate health insurance narrative:', err);
    return {
      indicator1: 'N/A',
      indicator2: 'N/A',
      smartNarrative: 'Smart narrative unavailable.'
    };
  }
}
